import { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import UiLink from "@rnb/ui-link";
import OverlayLink from "components/block-elements/overlay-link/overlay-link";

export default class LinkWrapper extends Component {
  static propTypes = {
    url: PropTypes.string,
    toOverlay: PropTypes.bool,
    onPreNavigate: PropTypes.func,
    locationState: PropTypes.object,
    className: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.targetClicked = false;
  }

  onPreNavigate(event) {
    if (typeof this.props.onPreNavigate !== "function" || this.targetClicked) {
      return;
    }

    this.targetClicked = true;

    event.persist();
    event.preventDefault();

    this.props.onPreNavigate(event);
    event.target.click();
  }

  render() {
    return (
      <UiLink
        routerLink={this.props.toOverlay ? OverlayLink : Link}
        {...this.props}
        onClick={(event) => this.onPreNavigate(event)}
      >
        {this.props.children}
      </UiLink>
    );
  }
}
